import curry from 'lodash/curry'
import pbjs from 'protobufjs'

import jpProto from './jpProto.json'

const jpProtoRoot = pbjs.Root.fromJSON(jpProto)

export const responseCodeMap = {
  1000: 'HeartBeat',
  1001: 'Snap',
  1002: 'OrderStr',
  1003: 'Trade',
  1004: 'Trend',
  1005: 'Kline',
  1006: 'Response',
  1007: 'OrderBrokerStr',
  1009: 'CapitalFlow',
  1010: 'ExtendSnap',
  1011: 'IndexQuote',
  1013: 'IndustryRankList',
  1014: 'RankList',
  1015: 'TradeStatisticsList',
  1016: 'StockStatus',
  1017: 'ResponseData',
  1018: 'BrokerRankingList',
  1019: 'Liquidation',
  1020: 'WarrantQuote',
  1021: 'MarketPremium',
  1022: 'UnderlyingStatistics',
  2013: 'CapitalDistribute'
}

export const commandMapToProtocol = {
  // 心跳
  0: '1000',

  // 快照
  1: '1001',
  2: '1001',

  // trade
  3: '1003',
  4: '1003',

  // order
  5: '1002',
  6: '1002',

  // 分时
  7: '1004',
  8: '1004',

  // K线
  9: '1005',
  10: '1005',

  // 经纪席位
  12: '1007',
  13: '1007',

  // 交易状态
  // 资金流向
  16: '1009',
  17: '1009',

  // 扩展行情
  18: '1010',
  19: '1010',

  // 指数行情
  20: '1011',
  21: '1011',

  // 板块
  24: '1013',
  25: '1013',

  // 排行版
  26: '1014',
  27: '1014',

  // 成交统计
  28: '1015',
  29: '1015',

  // 个股状态
  30: '1016',
  31: '1016',

  // 十大经纪商
  32: '1018',
  33: '1018',

  // 权证扩展行情
  34: '1020',
  35: '1020',

  // 多市场溢价
  36: '1021',
  37: '1021',

  // 正股期权callPut数量
  38: '1022',
  39: '1022',

  // 资金成交分布
  40: '2013',
  41: '2013'
}

export const protocolsName = {
  1000: '心跳',
  1001: '快照',
  1003: '逐笔',
  1002: '挂单',
  1004: '分时',
  1005: 'K线',
  1007: '经纪席位',
  1009: '资金流向',
  1010: '扩展行情',
  1011: '指数行情',
  1013: '板块',
  1014: '排行版',
  1015: '交易统计',
  1016: '交易状态',
  1018: '经纪排名',
  1020: '权证扩展行情',
  1021: '市场溢价',
  1022: '看涨看跌比例',
  2013: '资金成交统计'
}

// TODO: 工具函数化，并重点文档：arraybuffer 的高兼容性做法
function blobToText(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => {
      resolve(reader.result)
    }

    reader.onerror = () => {
      reject(new Error('blob handle error!'))
    }

    reader.readAsText(blob)
  })
}

// TODO: 工具函数化，并重点文档：arraybuffer 的高兼容性做法
function blobToArrayBuffer(data) {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.readAsArrayBuffer(data)
  })
}

export const decoder = curry(async (protoRoot, data) => {
  // 解析协议、数据预处理
  const [protocolCode, messageArrayBuffer] = await Promise.all([blobToText(data.slice(2, 6)), blobToArrayBuffer(data)])

  // 根据协议解码数据
  const res = protoRoot.lookupType(responseCodeMap[protocolCode]).decode(new Uint8Array(messageArrayBuffer))

  return [protocolCode, res]
})

export const jpDecoder = decoder(jpProtoRoot)
